var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
    'z-list-item',
    { 'z-list-item--centered' : _vm.centered && _vm.icon }
]},[(_vm.iconName)?_c('z-icon',{staticClass:"z-list-item__icon",attrs:{"name":_vm.iconName}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"z-list-item__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }